export default __webpack_public_path__ + "static/media/ico-mute.faa3ec0f.svg";